import { styled } from '@linaria/react';
import { motion } from 'framer-motion';

export const GridStructure = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  padding: 2px;
  outline: 1px solid var(--color-gray-300);
`;

export const BaseCodeWrapper = styled.div`
  --block-padding-override: 8px;
  --inline-padding-override: 8px;
  flex: 1;
  position: relative;
  align-self: center;
  background: hsl(210deg 30% 12%);
  padding: 16px;
  border-radius: 8px;
  overflow: auto;
  max-width: 100%;
`;

export const LabeledColumn = styled(motion.div)`
  --border-width: 2px;
  --start-radius: 5px;
  position: relative;
  margin-top: -2rem;
  border-left: var(--border-width) dashed var(--color-gray-500);
  border-right: var(--border-width) dashed var(--color-gray-500);
  padding: 0 10px;
  line-height: calc(2rem - 3px);
  text-align: center;
  background: hsl(210deg 15% 6% / 0.6);
  font-weight: var(--font-weight-bold);
  transform-style: preserve-3d;

  /*
    The columns protrude above the container, to show the label. This protrusion should be rounded. If I use a standard border-radius, though, it means that we wind up with 1 continuous clockwise border, and so the left/right sides don't align well. Because multiple columns are side-by-side, this looks messy / janky.

    To fix it, our main column only has left/right borders. Then, with a pseudo-element, we create a little cap that sits above, and provides the rounded top border. With the current --start-radius, it flows smoothly, at least in Chrome. It's a bit buggy in Safari, but IDK what to do about that.
  */
  &::after {
    content: '';
    position: absolute;
    top: calc(var(--start-radius) * -1);
    left: calc(var(--border-width) * -1);
    right: calc(var(--border-width) * -1);
    width: calc(100% + var(--border-width) * 2);
    height: var(--start-radius);
    border: var(--border-width) dashed var(--color-gray-500);
    border-bottom: unset;
    border-radius: var(--start-radius) var(--start-radius) 0px 0px;
  }
`;

export const LabeledRow = styled(motion.div)`
  --border-width: 2px;
  --start-radius: 5px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: -2.5rem;
  border-top: var(--border-width) dashed var(--color-gray-500);
  border-bottom: var(--border-width) dashed var(--color-gray-500);
  padding: 0 10px;
  background: hsl(210deg 15% 6% / 0.6);
  font-weight: var(--font-weight-bold);
  transform-style: preserve-3d;

  /*
    See note in LabeledColumn to understand why this pseudo-element
    is necessary.
  */
  &::after {
    content: '';
    position: absolute;
    top: calc(var(--border-width) * -1);
    left: calc(var(--start-radius) * -1);
    bottom: calc(var(--border-width) * -1);
    width: var(--start-radius);
    height: calc(100% + var(--border-width) * 2);
    border: var(--border-width) dashed var(--color-gray-500);
    border-right: unset;
    border-radius: var(--start-radius) 0px 0px var(--start-radius);
  }
`;
